export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MenuItemMob.vue?vue&type=template&id=562fc0ae&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/MenuItemMob.vue?vue&type=template&id=562fc0ae&scoped=true&
// module id = 143
// module chunks = 0